import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=113b7122&"
import script from "./baseInfo.vue?vue&type=script&lang=ts&"
export * from "./baseInfo.vue?vue&type=script&lang=ts&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports